const shopColors = [
    { text: 'Dark blue', value: 'blueDark' },
    { text: 'Light blue', value: 'blueLight' },
    { text: 'Orange', value: 'orange' },
    { text: 'Purple', value: 'purple' },
    { text: 'Yellow', value: 'yellow' }
]

export default shopColors
